export default __webpack_public_path__ + "static/media/food25.73f0a74a.jpg";